export const MobileCta = () => (
  <div className="mobile-cta" data-testid="mobile-sticky-cta">
    <button
      className="btn-accent w-full"
      data-testid="mobile-cta-button"
      onClick={() => {
        const el = document.getElementById("register");
        if (window.__lenis) window.__lenis.scrollTo(el, { duration: 1.2 });
        else el?.scrollIntoView({ behavior: "smooth" });
      }}
    >
      ✓ RESERVE MY FREE SEAT
    </button>
  </div>
);
